export default __webpack_public_path__ + "static/omni-1-0a09f2b19b4a48522998a6489e939bb5.webp";